(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 61540:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(46940);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _components_wizard_flows_PrivacyPolicy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13262);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95871);



var Privacy = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        width: "100%",
        maxWidth: "7xl",
        m: "auto",
        p: 5,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_wizard_flows_PrivacyPolicy__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Privacy);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3262,9774,2888,179], function() { return __webpack_exec__(61540); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);